
import { useTheme } from "@/components/theme-provider";
import { getThemeColors, CSS_CHART_COLORS } from "../constants/chartColors";

export const useThemeColors = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  
  const colors = getThemeColors(isDark);
  
  return {
    colors,
    isDark,
    cssColors: CSS_CHART_COLORS
  };
};
